import i18n from "lang";

export const AUTH_TOKEN = "auth_token";
export const REFRESH_TOKEN = "refresh_token";
export const COMPANY_ID = "company_id";
export const FACTORY_ID = "factory_id";
export const ASSEMBLYLINE_ID = "assemblyLine_id";
export const MILLINGLINE_ID = "millingLine_id";
export const BOILER_ID = "boiler_id";
export const DISTILLERY_BOILER_ID = "distillery_boiler_id";
export const LANG_KEY = "lang_key";
// Set when the user picks a language with the language switch on this device. That choice
// then wins over the profile language at the next sign in.
export const LANG_CHOSEN_KEY = "lang_key_chosen";
// The chosen theme ("light" or "dark"), kept like the language (QA UI-07).
export const THEME_KEY = "theme_key";
export const USER_ID = "user_id";
export const UPLOADED_IMAGE_PATH =
  "https://s3-ap-southeast-1.amazonaws.com/file.sugarcmms/AutoCadImages/";
export const UPLOADED_FILE_PATH =
  "https://s3-ap-southeast-1.amazonaws.com/file.sugarcmms/AutoCadFiles/";
export const REQUIRED_MSG = [
  {
    required: true,
    message: i18n.t("FieldRequired"),
  },
];

export const USERPERMISSIONLIST = "userPermission_list";
export const ROLESLIST = "roles_list";
//  export const LANG_KEY="lang_key";
